import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import FlexRow, { IFlexRow } from '@ui/atoms/FlexRow';
import SubheadingText from '@ui/atoms/SubheadingText';

import aligned from '@ui/styled/Aligned';

interface IIconHeaderProps {
	Icon: string;
	title: string;
	description: string;
}

const AlignedRow = aligned<IFlexRow>(FlexRow);

const IconHeader: FC<IIconHeaderProps> = ({ description, Icon, title }) => {
	return (
		<AlignedRow gap="sm" alignItems="center">
			<Icon height="4rem" width="4rem" style={{ flexShrink: 0 }} />
			<FlexColumn gap="xs">
				<SubheadingText>{title}</SubheadingText>
				<BasicText variant="fineprint">{description}</BasicText>
			</FlexColumn>
		</AlignedRow>
	);
};

export default styled(IconHeader)``;
